import { get, post, put } from '../request';
import { BASE } from './config';

export const UserApi = {
  profile() {
    return get(`${BASE}/user/profile`);
  },
  userInfoAll({ isMe = false, beUserId } = {}) {
    return post(`${BASE}/user/info/all`, {
      is_me: isMe,
      be_user_id: beUserId,
    });
  },
  updateProfile(payload) {
    return put(`${BASE}/user/profile`, payload);
  },
  points() {
    return get(`${BASE}/user/points`);
  },
  coupons() {
    return get(`${BASE}/user/coupons`);
  },
};

export default UserApi;
